import React, { useEffect, useState } from 'react';

import { AppleSocialLogin, GoogleSocialLogin, login } from 'app/shared/reducers/authentication';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import FacebookIcon from 'app/components/icons/login-page-icons/facebook-icon';
import GoogleIcon from 'app/components/icons/login-page-icons/google-icon';
import AppleIcon from '@mui/icons-material/Apple';
import TwitterIcon from 'app/components/icons/login-page-icons/twitter-icon';
import AppleLogoIcon from 'app/components/icons/login-page-icons/apple-icon';
import { Button, Grid, TextField, Typography, useTheme, Box } from '@mui/material';
import { Navigate, useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { Field, Form, Formik } from 'formik';
import * as Yup from 'yup';
import LoaderIcon from 'app/components/common/loader-icon/loader-icon';
import { useGoogleLogin } from '@react-oauth/google';
import Cookies from 'js-cookie';
import WhiteTwitterIcon from 'app/components/icons/login-page-icons/white-twitter-icon';
import { getPhoneNumber } from 'app/shared/reducers/phone-verification';
import { fetchOrganization } from 'app/shared/reducers/organization';
import toast from 'react-hot-toast';
import { clearExistingActivities, clearSearchKeyword } from 'app/shared/reducers/activity-filter';
import AppleSignin from 'react-apple-signin-auth';
import AppleLogin from 'react-apple-login';
import sha256 from 'crypto-js/sha256';
import { v4 as uuidv4 } from 'uuid';

import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import IconButton from '@mui/material/IconButton';

interface LoginPageProps {
  currentComponent?: any;
  setCurrentComponent?: any;
  setEnteredMail?: any;
  handleAuthModalClose?: any;
}
const LoginPage = ({ currentComponent, setCurrentComponent, setEnteredMail, handleAuthModalClose }: LoginPageProps) => {

const [showPassword,setShowPassword]=useState(false)

const handleClickShowPassword=()=>{
  setShowPassword(prev=>!prev)
}

  const navigate = useNavigate();
  const location = useLocation();
  const handleForgotPassword = () => {
    setCurrentComponent('forgotPassword');
  };
  const handleSignUp = () => {
    setCurrentComponent('signup');
  };

  const dispatch = useAppDispatch();

  const theme = useTheme();
  const isDarkMode = theme.palette.mode === 'dark';
  const isAuthenticated = useAppSelector(state => state.authentication.isAuthenticated);
  const loading = useAppSelector(state => state.authentication.loading);
  const loginSuccess = useAppSelector(state => state.authentication.loginSuccess);
  const errorMessage = useAppSelector(state => state.authentication.errorMessage);
  const showModalLogin = useAppSelector(state => state.authentication.showModalLogin);
  // const isUserPreferenceDone = useAppSelector(state => state.authentication.userPreferencesDone);

  const buttonStyle = {
    marginBottom: '10px',
    marginRight: '5px',
    backgroundColor: theme.palette.secondary.dark,
    border: '1px solid #674BFF',
    borderRadius: '32px',
    padding: '6px',
    color: '#292d34',
    boxShadow: 'none',
    '&:active, &:focus, &:hover': {
      backgroundColor: theme.palette.secondary.dark,
      border: '1px solid #674BFF !important',
      borderRadius: '32px',
      padding: '6px',
      color: '#292d34 !important',
      boxShadow: 'none',
    },
  };

  const heading = {
    color: theme.textColor.mainHeading,
    marginBottom: '10px',
    marginTop: '0px',
    fontSize: '15px',
    fontWeight: '600',
  };

  const signupText = {
    color: theme.textColor.heading,
    fontSize: '11px',
    fontWeight: '600',
  };

  const invitedOrgId = parseInt(localStorage.getItem('invitedOrgId'));
  const redirectUrl = `${location.pathname}${location.search}`;
  const [searchParams] = useSearchParams();
  const invited = searchParams.get('invited');
  const isInvited = invited === 'true';
  const urlOrgId = searchParams.get('org');
  const handleLogin = async (email: string, password: string) => {
    try {
      let res = await dispatch(login(email, password));
      console.log('check', res);
      const isUserPreferenceDone = sessionStorage.getItem('userPreferencesCompleted');
      const myCookieValue = Cookies.get('jhi-authenticationToken');
      const authenticationToken = myCookieValue;
      const authenticated = !!authenticationToken;
      if (authenticated) {
        toast.success('Welcome to ReachAMY!');
        await dispatch(getPhoneNumber());
        if (invitedOrgId || isInvited) {
          dispatch(fetchOrganization(invitedOrgId));

          if (urlOrgId) {
            navigate(`/organization/${urlOrgId}`);
          } else {
            handleAuthModalClose();
          }
        } else {
          console.log('login page ');
          dispatch(clearSearchKeyword());
          if (isUserPreferenceDone === 'true') {
            navigate(redirectUrl);
          } else {
            navigate('/welcome');
          }
        }
      }
    } catch (error) {
      console.error('Error during login:', error);
      // Handle the error as needed, e.g., show a message to the user
    }
  };
  const socialLogin = useGoogleLogin({
    onSuccess: async codeResponse => {
      try {
        // Dispatch the social login action
        let res = await dispatch(GoogleSocialLogin({ code: codeResponse.code }));

        if ((res as any)?.payload?.status === 'PROFILE_INCOMPLETE') {
          setCurrentComponent('socialSignupCompletion');
          return;
        }

        if (res) {
          console.log('check login insided');
          // Check user authentication and preferences
          const isUserPreferenceDone = sessionStorage.getItem('userPreferencesCompleted');
          const myCookieValue = Cookies.get('jhi-authenticationToken');
          const authenticationToken = myCookieValue;
          const authenticated = !!authenticationToken;

          if (authenticated) {
            toast.success('Welcome to ReachAMY!');
            if (invitedOrgId || isInvited) {
              dispatch(fetchOrganization(invitedOrgId));

              if (urlOrgId) {
                navigate(`/organization/${urlOrgId}`);
              } else {
                handleAuthModalClose();
              }
            } else {
              let res1 = dispatch(clearSearchKeyword());
              let res2 = dispatch(clearExistingActivities());
              if (res1 && res2) {
                if (isUserPreferenceDone === 'true') {
                  navigate(location.pathname);
                } else {
                  navigate('/welcome');
                }
              }
            }
          }
        }
      } catch (error) {
        console.error('Error during social login:', error);
        // Handle the error as needed, e.g., show a message to the user
      }
    },
    flow: 'auth-code',
    onError: error => console.log('error:', error),
  });

  const loginUser = ({ email, password }) => {
    handleLogin(email, password);
  };
  // Validation schema
  const validationSchema = Yup.object().shape({
    email: Yup.string()
      .required('Email cannot be empty!')
      .matches(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,}$/, 'Invalid email format!'),
    password: Yup.string().required('Password cannot be empty!').min(4, 'Password must be 8 characters long.'),
  });

  // Formik form submission handler
  const handleLoginSubmit = (values, { setSubmitting }) => {
    Cookies.remove('jhi-authenticationToken');
    // localStorage.clear();
    sessionStorage.clear();
    setSubmitting(true);
    loginUser(values);
    setSubmitting(false);
  };
  const handleAppleLoginSuccess = async (response: any) => {
    try {
      console.log('Apple response:', response);

      // Extract the authorization and user data from the response
      const { authorization, user } = response;
      if (!authorization) {
        throw new Error('Authorization data is missing in the Apple response.');
      }

      const { code, id_token } = authorization;
      if (!code || !id_token) {
        throw new Error('Authentication code or ID token is missing.');
      }

      // Optional: Extract user data
      const email = user?.email || '';
      const firstName = user?.name?.firstName || '';
      const lastName = user?.name?.lastName || '';

      // Dispatch the AppleSocialLogin action with the extracted data
      const res = await dispatch(
        AppleSocialLogin({
          code,
          idToken: id_token,
          email,
          firstName,
          lastName,
        })
      );

      if ((res as any)?.payload?.status === 'PROFILE_INCOMPLETE') {
        setCurrentComponent('socialSignupCompletion');
        return;
      }

      if (res) {
        console.log('Check login inside');

        // Check user authentication and preferences
        const isUserPreferenceDone = sessionStorage.getItem('userPreferencesCompleted');
        const myCookieValue = Cookies.get('jhi-authenticationToken');
        const authenticationToken = myCookieValue;
        const authenticated = !!authenticationToken;

        if (authenticated) {
          toast.success('Welcome to ReachAMY!');

          if (invitedOrgId || isInvited) {
            await dispatch(fetchOrganization(invitedOrgId));

            if (urlOrgId) {
              navigate(`/organization/${urlOrgId}`);
            } else {
              handleAuthModalClose();
            }
          } else {
            dispatch(clearSearchKeyword());
            dispatch(clearExistingActivities());

            if (isUserPreferenceDone === 'true') {
              navigate(location.pathname);
            } else {
              navigate('/welcome');
            }
          }

          // Optionally, close the Apple Sign-In popup if it's still open
          // This depends on how the AppleSignin component handles popups
        } else {
          throw new Error('Login response is invalid.');
        }
      } else {
        throw new Error('Failed to dispatch AppleSocialLogin.');
      }
    } catch (error) {
      console.error('Error in handleAppleLoginSuccess:', error);
    }
  };
  const isOrganizationPage = /^\/organization\/\d+/.test(location.pathname);
  const getBaseDomain = (url: string) => {
    const urlParts = url.split('/');
    return urlParts[2];
  };
  const domain = getBaseDomain(window.location.href);
  const appleSigninButton = (
    <AppleSignin
      authOptions={{
        clientId: 'com.reachamyofficial.app.signin',
        scope: 'email name',
        redirectURI: `https://${domain}`,
        state: uuidv4(),
        nonce: uuidv4(),
        usePopup: true,
      }}
      uiType="light"
      skipScript={false}
      onSuccess={response => handleAppleLoginSuccess(response)}
      onError={error => {
        console.error('Apple Login Error:', error);
      }}
      render={props => (
        <Button
          {...props}
          variant="contained"
          sx={{
            ...buttonStyle,
          }}
        >
          <AppleIcon style={{ color: isDarkMode ? 'white' : '#000', width: '20px', height: '20px', marginRight: '2px' }} />
          <span>
            <Typography sx={{ textTransform: 'capitalize', color: theme.palette.primary.light, fontSize: '11px', fontWeight: '600' }}>
              Sign in with Apple
            </Typography>
          </span>
        </Button>
      )}
    />
    // <AppleLogin
    //   clientId={'com.reachamyofficial.app.signin'}
    //   redirectURI={'https://reachamy-269ac.firebaseapp.com/__/auth/handler'}
    //   responseType={'code'}
    //   responseMode={'query'}
    //   usePopup={false}
    //   designProp={{
    //     height: 30,
    //     width: 140,
    //     color: '#292d34',
    //     border: true,
    //     type: 'sign-in',
    //     border_radius: 15,
    //     scale: 1,
    //     locale: 'en_US',
    //   }}
    //   callback={handleAppleLoginSuccess}
    // />
  );

  return (
    <>
      <style>
        {`.css-9dyvjb-MuiFormControl-root-MuiTextField-root {
        background:none !important
      }`}
      </style>
      {showModalLogin && (
        <Grid
          container
          spacing={2}
          width={'100%'}
          padding={'10px'}
          direction={'column'}
          margin={'0'}
          justifyContent={'center'}
          alignItems={'center'}
        >
          <div onClick={() => navigate('/')}>
            <img src="content/images/logos/reachamy-logo.webp" alt="reach amy logo" style={{ height: '58px' }} />
          </div>
          <h6 style={heading}>We look forward to your company!</h6>
          <div className="col-12 d-flex  justify-content-center align-content-center">
            <Button
              variant="contained"
              color="primary"
              sx={buttonStyle}
              onClick={() => {
                socialLogin();
              }}
            >
              <GoogleIcon style={{ width: '20px', height: '20px', marginRight: '2px' }} />

              <span>
                <Typography sx={{ textTransform: 'capitalize', color: theme.palette.primary.light, fontSize: '11px', fontWeight: '600' }}>
                  Continue with Google
                </Typography>
              </span>
            </Button>

            {appleSigninButton}
          </div>

          <div
            style={{
              marginBottom: '5px',
              alignItems: 'center',
            }}
          >
            <Button
              variant="text"
              style={{
                background: '#DFDFDF',
                borderRadius: '50%',
                minWidth: '30px',
                height: '25px',
                padding: '0',
                color: '#292D34',
              }}
            >
              <Typography textTransform={'capitalize'} fontSize={'10px'} fontWeight={'600'}>
                Or
              </Typography>
            </Button>
          </div>
          <Formik
            initialValues={{
              email: '',
              password: '',
            }}
            validationSchema={validationSchema}
            onSubmit={handleLoginSubmit}
          >
            {({ errors, touched, isSubmitting, handleChange }) => (
              <Form>
                <Grid>
                  <Grid container sx={{ justifyContent: 'center' }}>
                    <Grid item container sx={{ justifyContent: 'center', direction: 'column' }} xs={6} md={6} gap={1}>
                      <Field
                        type="text"
                        name="email"
                        placeholder="Email"
                        as={TextField}
                        required
                        inputProps={{
                          style: {
                            height: '12px',
                          },
                        }}
                        sx={{
                          backgroundColor: theme.palette.secondary.dark,
                          color: theme.textColor.heading,
                          width: '80%',
                          marginBottom: '6px',
                        }}
                        error={touched.email && !!errors.email}
                        helperText={touched.email && errors.email}
                        onChange={(e: any) => {
                          setEnteredMail(e.target.value);
                          handleChange(e);
                        }}
                      />


                      <Field
                        type={showPassword ? 'text' : 'password'}
                        name="password"
                        placeholder="Password"
                        as={TextField}
                        required
                        inputProps={{
                          style: {
                            height: '16px',
                          },
                        }}
                        sx={{
                          backgroundColor: theme.palette.secondary.dark,
                          color: theme.textColor.heading,
                          width: '80%',
                          marginBottom: '6px',
                        }}
                        error={touched.password && !!errors.password}
                        helperText={touched.password && errors.password}
                        InputProps={{
                          endAdornment: (
                            <IconButton onClick={handleClickShowPassword} edge="end">
                              {showPassword ? (
                                <VisibilityOff sx={{ fontSize: 20, color: theme.palette.primary.light }} />
                              ) : (
                                <Visibility sx={{ fontSize: 20, color: theme.palette.primary.light }} />
                              )}
                            </IconButton>
                          ),
                        }}
                      />

                      <Box
                        sx={{
                          backgroundColor: 'transparent',
                          border: 'none',
                          color: theme.palette.primary.light,
                          justifyContent: 'flex-end',
                          width: '80%',
                          height: '5px',
                          fontSize: '11px',
                          padding: '1px',
                          marginBottom: '10px',
                          textAlign: 'end',
                          cursor: 'pointer',
                        }}
                        onClick={handleForgotPassword}
                      >
                        <Typography sx={{ textTransform: 'capitalize', fontSize: '11px' }}>Forgot password?</Typography>
                      </Box>
                      {errorMessage !== null && (
                        <Grid
                          container
                          sx={{
                            justifyContent: 'center',
                            padding: '5px',
                            color: theme.palette.error.main,
                            fontSize: '12px',
                            textAlign: 'center',
                          }}
                        >
                          {errorMessage === 'Rejected'
                            ? 'You have already signed up with us. Please log in using your email and password.'
                            : errorMessage}
                        </Grid>
                      )}
                      <Button
                        type="submit"
                        variant="contained"
                        sx={{
                          marginBottom: '10px',
                          height: theme.createActivity.height,
                          backgroundColor: theme.palette.primary.light,
                          borderRadius: theme.createActivity.borderRadius,
                          // color: theme.palette.secondary.dark,
                          color: 'white',
                          borderColor: theme.palette.primary.main,
                          width: '80%',
                          boxShadow: 'none',
                          '&:active, &:focus, &:hover': {
                            backgroundColor: theme.createActivity.backgroundColor.hover,
                            boxShadow: 'none',
                          },
                        }}
                        endIcon={loading ? <LoaderIcon /> : null}
                        disabled={isSubmitting}
                      >
                        Log in
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
              </Form>
            )}
          </Formik>
          <span style={signupText} className="d-flex">
            Do not have an account?
            <a style={{ paddingLeft: '1px', paddingTop: '1px' }} onClick={handleSignUp}>
              <Typography
                sx={{
                  textTransform: 'capitalize',
                  fontSize: '11px',
                  color: theme.palette.primary.light,
                  fontWeight: '600',
                }}
              >
                Sign Up
              </Typography>
            </a>
          </span>
          <span style={{ fontSize: '11px', textAlign: 'justify', width: '70%', fontWeight: '600' }}>
            Your information is safe and secure. By signing up, you agree to our{' '}
            <span
              style={{
                marginLeft: '1px',
                marginRight: '1px',
                color: theme.palette.primary.light,
                textTransform: 'capitalize',
                fontSize: '11px',
              }}
            >
              <span style={{ cursor: 'pointer' }} onClick={() => navigate('/privacy-policy')}>
                privacy policy
              </span>
              , &nbsp;
              <span style={{ cursor: 'pointer' }} onClick={() => navigate('/cookie-policy')}>
                cookie policy
              </span>
              , &nbsp;
              <span style={{ cursor: 'pointer' }} onClick={() => navigate('/member-agreement')}>
                Member agreement
              </span>
            </span>
            &nbsp;and that we may share your personal information with our partners to verify your account.
          </span>
        </Grid>
      )}
    </>
  );
};

export default LoginPage;
